__turbopack_context__.v({
  "empty": "TableWidgets-module__c55k-q__empty",
  "emptyActions": "TableWidgets-module__c55k-q__emptyActions",
  "emptyDesc": "TableWidgets-module__c55k-q__emptyDesc",
  "emptyIcon": "TableWidgets-module__c55k-q__emptyIcon",
  "emptyTitle": "TableWidgets-module__c55k-q__emptyTitle",
});
